import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { t } from 'i18next';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';

export async function apiRequest<T = any>(
  method: HttpMethod,
  url: string,
  data?: any,
  headers: Record<string, string> = { 'Content-Type': 'application/json' }
): Promise<T> {
  const config: RequestInit = {
    method,
    headers: {
      ...headers,
      'Accept': 'application/json',
    },
    credentials: 'include', // Important for cookies, authorization headers with HTTPS
  };

  if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
    config.body = JSON.stringify(data);
  }

  const response = await fetch(url, config);
  
     if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response.json() as Promise<T>;
  
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateTime(date: Date | string) {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatDate(date: Date | string) {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function formatTimeAgo(date: Date | string) {
  const now = new Date();
  const pastDate = typeof date === 'string' ? new Date(date) : date;
  const diffMs = now.getTime() - pastDate.getTime();
  const diffMins = Math.round(diffMs / 60000);
  
  if (diffMins < 60) {
    return t('billing.plans.timeAgoFormat.minute', { count: diffMins });
  }
  
  const diffHours = Math.round(diffMins / 60);
  if (diffHours < 24) {
    return t('billing.plans.timeAgoFormat.hour', { count: diffHours });
  }
  
  const diffDays = Math.round(diffHours / 24);
  return t('billing.plans.timeAgoFormat.day', { count: diffDays });
}

export function getInitials(name: string) {
  const names = name.split(' ');
  if (names.length > 1) {
    return `${names[0][0]}${names[1][0]}`;
  }
  return names[0][0];
}
